import{css as n}from"styled-components";var r=function(){return n(["margin:0;padding:0;"])};export{r as clearMarginPadding};
